import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import beSwitchAllowanceYear from 'actions/timeoff/beSwitchAllowanceYear.action';
import beTimeOffAllowances from 'actions/timeoff/beTimeOffAllowances.action';
import beTimeOffReport from 'actions/timeoff/beTimeOffReport.action';
import TypedOption from 'components/form/TypedOption.component';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonAllowanceYear, selectCurrentSalonCalendarMode, selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import logger from 'utils/logger.util';
import c from 'utils/values/constant.util';

import CN from './StaffAllowancesHeader.module.scss';

const L = logger('StaffAllowancesHeader');

const TIME_OFF_YEAR_RANGE = c({
  taxYear: 'Tax Year',
  calendarYear: 'Calendar Year',
});

const StaffAllowancesHeader = ({ allowanceYear, beSwitchAllowanceYear, beTimeOffAllowances, beTimeOffReport, calendarMode, fetchStylistsBySalon, salonId }) => {
  const [checked, setChecked] = useState(allowanceYear);

  const { t } = useTranslation();

  const refreshTimeOffData = useCallback(
    (FTAG) => {
      L.unignore(FTAG, 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId));
      L.unignore(FTAG, 'beTimeOffReport:', beTimeOffReport({ salonId }));
      L.unignore(FTAG, 'beTimeOffAllowances:', beTimeOffAllowances({ salonId }));
    },
    [beTimeOffAllowances, beTimeOffReport, fetchStylistsBySalon, salonId],
  );

  //TODO: Check US tax year begin-end
  const handleYearChange = useCallback(() => {
    beSwitchAllowanceYear({
      salonId,
      allowanceYear: checked === TIME_OFF_YEAR_RANGE.calendarYear ? TIME_OFF_YEAR_RANGE.taxYear : TIME_OFF_YEAR_RANGE.calendarYear,
    })
      .then((result) => {
        if (result.is.ok) {
          refreshTimeOffData('handleYearChange');
        }
        if (checked === TIME_OFF_YEAR_RANGE.calendarYear) {
          setChecked(TIME_OFF_YEAR_RANGE.taxYear);
        } else {
          setChecked(TIME_OFF_YEAR_RANGE.calendarYear);
        }
      })
      .catch((e) => L.warn('handleYearChange()', 'something went wrong with the fetch: ', { e }));
  }, [beSwitchAllowanceYear, checked, refreshTimeOffData, salonId]);

  return (
    <div data-bem="StaffTimeOffAllowances__header" className={cn(CN.container, CN[calendarMode])}>
      <span className={CN.title}>{t('humanResources.timeOffSettings.allowancesPerStaff.title')}</span>
      <div className={CN.radioContainer}>
        <div className={CN.option}>
          <TypedOption label={t('humanResources.timeOffSettings.allowancesPerStaff.checkbox1Text')} value={checked === TIME_OFF_YEAR_RANGE.calendarYear} onChange={handleYearChange} />
        </div>
        <div className={CN.option}>
          <TypedOption label={t('humanResources.timeOffSettings.allowancesPerStaff.checkbox2Text')} value={checked === TIME_OFF_YEAR_RANGE.taxYear} onChange={handleYearChange} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allowanceYear: selectCurrentSalonAllowanceYear(state),
  calendarMode: selectCurrentSalonCalendarMode(state),
  salonId: selectCurrentSalonId(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      beSwitchAllowanceYear,
      beTimeOffReport,
      beTimeOffAllowances,
      fetchStylistsBySalon,
    },
    dispatch,
  );

const StaffAlowancesHeaderHoc = connect(mapStateToProps, mapDispatchToProps)(StaffAllowancesHeader);

export default StaffAlowancesHeaderHoc;
